export const enum WidgetVersionChangeMask {
  Ignore = 0x0, // do nothing
  Store = 0x1, // just store the version
  ReloadPage = 0x2 // store the version and reload the page
}

export function getWidgetVersionChangeActions(currentVersion: number | undefined, newVersion: number | undefined) {
  if (newVersion === -1) {
    // we use -1 as a special key that means do not ever refresh.
    // this gives us a stopgap where we could force this to -1 on
    // backend if we're seeing something weird in the wild with
    // refreshes happening when they shouldn't be.
    return WidgetVersionChangeMask.Ignore;
  }

  if (newVersion !== undefined && (currentVersion === undefined || newVersion > currentVersion)) {
    if (currentVersion !== undefined) {
      return WidgetVersionChangeMask.Store | WidgetVersionChangeMask.ReloadPage;
    } else {
      return WidgetVersionChangeMask.Store;
    }
  }

  return WidgetVersionChangeMask.Ignore;
}
